import React, { Component, Fragment } from "react";
import _ from 'lodash';
import { connect } from "@common/components/base.component";
import DDadosItem from "@common/components/ddados/ddados.item";
import camposDinamicosSelector from "../store/camposDinamicos.selectors";
import camposDinamicosActions from "../store/camposDinamicos.actions";
import CamposDinamicosCaracteristica from '@common/components/camposDinamicosCaracteristicas/components/camposDinamicosCaracteristicas.component';
import { Row, Col } from "react-bootstrap";
import autoBind from "react-autobind";

class Container extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  onChangeCampoDinamico = value => this.props.camposDinamicosActions.setCamposDinamicos(value);

  render() {
    const { arrayCaracteristicas } = this.props.camposDinamicosSelector.camposDinamicos;
    return (
      <CamposDinamicosCaracteristica
        state={arrayCaracteristicas}
        isView={this.props.isView}
        onChange={value => this.onChangeCampoDinamico(value)}
        isExterno
      />
    );
  }
}

export default connect({
  actions: {
    camposDinamicosActions
  },
  selectors: {
    camposDinamicosSelector
  }
})(Container);
